import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgRu48Rounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  "aria-label": "Russia",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#e7e7e7",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d43630",
  d: "M21.48 15.29H2.57a10 10 0 0 0 18.91 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#004fbb",
  d: "M22.05 12a9.5 9.5 0 0 0-.57-3.29H2.57a9.78 9.78 0 0 0 0 6.58h18.91a9.5 9.5 0 0 0 .57-3.29"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 2a10 10 0 0 0-9.43 6.71h18.91A10 10 0 0 0 12 2"
}));

export { SvgRu48Rounded as default };
//# sourceMappingURL=Ru48Rounded.js.map
